module.exports = __webpack_public_path__ + "img/sol_isol_pain1.f98f7908.png";